import { create } from 'zustand';
import { Job, MAX_GLB_BYTES } from './contracts.ts';

const lastJob = () => { try { return localStorage.getItem('tll-blender-last-job'); } catch { return null; } };
export const useBlenderSelection = create<{ id: string | null; select: (id: string) => void }>(set => ({
  id: lastJob(), select: id => { set({ id }); try { localStorage.setItem('tll-blender-last-job', id); } catch { /* Storage may be disabled. */ } },
}));
export async function studioRequest(route: string, init?: RequestInit): Promise<unknown> {
  const response = await fetch('/api/blender' + route, { ...init, headers: { ...init?.headers, 'x-tll-studio': '1' }, signal: AbortSignal.timeout(25_000) });
  let data: unknown;
  try { data = await response.json(); } catch { throw new Error('로컬 Studio를 실행한 뒤 다시 연결하세요.'); }
  if (!response.ok) throw new Error(typeof data === 'object' && data && 'error' in data ? String(data.error) : '요청을 처리하지 못했습니다.');
  return data;
}
export async function sendGLB(blob: Blob, name: string) {
  if (blob.size > MAX_GLB_BYTES) throw new Error('GLB는 64MiB 이하로 내보내세요.');
  const job = Job.parse(await studioRequest('/jobs', { method: 'POST', headers: { 'Content-Type': 'model/gltf-binary', 'X-Model-Name': encodeURIComponent(name) }, body: blob }));
  useBlenderSelection.getState().select(job.id);
  return job;
}
